<template>
  <div v-if="isOpen || isClosing" class="notification-dropdown-overlay" :class="{ 'closing': isClosing, 'mobile': isMobile }" @click="handleOverlayClick">
    <div class="notification-dropdown" :class="{ 'sidebar-collapsed': isSidebarCollapsed, 'closing': isClosing, 'mobile': isMobile }" @click.stop>

      <!-- Header -->
      <div class="notification-header">
        <div class="header-title-row d-flex align-items-center justify-content-between">
          <h3 class="notification-title pt-2">Notifications</h3>
          <div class="d-flex align-items-center gap-2">
            <button v-if="notifications && notifications.length > 0" class="mark-all-read-btn" @click="$emit('mark-all-read')" aria-label="Mark all as read">
              <img src="/img/icons/avid-icons/mark_as_read.svg" alt="Mark all as read" class="notification-check-icon">
              <span>Mark all as read</span>
            </button>
            <button class="close-btn" @click="$emit('close')" aria-label="Close notifications">
              <i class="fas fa-times me-0"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Filter Tabs -->
      <div class="notification-filters">
        <div class="filter-btn-group" role="group">
          <!-- <button type="button" class="filter-btn" @click="currentFilter = 'by-app'" :class="[currentFilter === 'by-app' ? 'btn-primary' : 'btn-white']">
            By App
          </button> -->
          <button type="button" class="filter-btn" @click="handleFilterChange('by-date-newest')" :class="[currentFilter === 'by-date-newest' ? 'btn-primary' : 'btn-white']">
            By Date Newest
          </button>          
          <button type="button" class="filter-btn" @click="handleFilterChange('by-date-oldest')" :class="[currentFilter === 'by-date-oldest' ? 'btn-primary' : 'btn-white']">
            By Date Oldest
          </button>
        </div>
      </div>

      <!-- Notifications List -->
      <div class="notification-content" ref="notificationContent" @scroll="handleScroll">
        <div v-if="isLoading && (!notifications || notifications.length === 0)" class="notifications-list mb-4">
          <p class="text-center">Loading notifications...</p>
        </div>
        <div v-else-if="!notifications || notifications.length === 0" class="notifications-list mb-4">
          <p>You have no new notifications.</p>
        </div>
        <transition-group v-else name="notification-fade" tag="div" class="notifications-list">
          <div v-for="notification in notifications" :key="notification.id" class="notification-item" @click="handleNotificationClick(notification)">
            <div class="notification-header-row d-flex align-items-center justify-content-between">
                <div class="notification-client-name text-start">
                    {{ notification.data?.client_name }}
                </div>
                <div class="d-flex align-items-center gap-2">
                    <div class="notification-date">
                        {{ formatDate(notification.created_at) }}
                    </div>
                    <div class="notification-status" @click="handleMarkAsReadClick(notification, $event)">
                        <img src="/img/icons/avid-icons/mark_as_read.svg" alt="Mark as read" class="notification-check-icon">
                    </div>
                </div>
            </div>
            <div class="notification-text">
              {{ notification.data?.error_msg || 'Notification message' }}
            </div>
          </div>
        </transition-group>
        <div v-if="isLoadingMore && notifications && notifications.length > 0" class="notifications-list mb-4">
          <p class="text-center">Loading more...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    notifications: {
      type: Array,
      default: () => []
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    isSidebarCollapsed: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isLoadingMore: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentFilter: 'by-date-newest',
      isClosing: false
    }
  },
  watch: {
    isOpen(newVal, oldVal) {
      if (oldVal && !newVal) {
        // Trigger closing animation
        this.isClosing = true
        setTimeout(() => {
          this.isClosing = false
        }, 300) // Match animation duration
      } else if (!oldVal && newVal) {
        // Reset filter when opening
        this.currentFilter = 'by-date-newest'
      }
    }
  },
  computed: {
  },
  methods: {
    handleOverlayClick() {
      this.$emit('close')
    },
    handleNotificationClick(notification) {
      // Navigate to the notification URL (like View Details previously did)
      if (notification.data?.url) {
        window.open(notification.data.url, '_blank')
      }
    },
    handleMarkAsReadClick(notification, event) {
      // Prevent the click from bubbling up to the notification item
      event.stopPropagation()
      // Mark as read without navigation
      this.$emit('mark-read', notification)
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: 'numeric',
        year: 'numeric'
      })
    },
    handleFilterChange(filter) {
      if (this.currentFilter !== filter) {
        this.currentFilter = filter
        this.$emit('filter-changed', filter)
      }
    },
    handleScroll(event) {
      const element = event.target
      const scrollBottom = element.scrollHeight - element.scrollTop - element.clientHeight
      
      // Load more when within 100px of bottom
      if (scrollBottom < 100 && this.hasMore && !this.isLoadingMore && !this.isLoading) {
        this.$emit('load-more')
      }
    }
  }
}
</script>